<template>
  <div :id="this.Processing['id_processing']" class="fill-height map">
  </div>
</template>

<script>
import { HorusPolygonEditor, HorusPolylineEditor, HorusVertexMarker } from "../../helpers/leaflet/horus-leaflet-editor"
import { BASE_MAX_ZOOM, BASE_MIN_ZOOM, FEATURE_GROUPS } from "../../helpers/leaflet/constants"
import { NOTIFICATION_TYPES, NotificationOptions } from "../../helpers/notify"
import Wkt from "wicket"
import { getPolylineDistance } from "../../helpers/spatial"
import {
  createField,
  createProcessingGeometries,
  listFieldsByProcessingShared,
  listProcessingGeometriesByProcessingShared,
} from "../../api/api-project"
import { forEach } from "lodash/collection"
import { FloatingCardsEventBus, MapViewEventBus } from "../../helpers/mapview/events"
import { GEOMETRY_TYPES } from "../../helpers/geometries/constants"
import { PostProcessingsTilesMixin, ProcessingsTilesMixin } from "../../helpers/mapview/mixins-shared"

const _Processing = Symbol.for("_Processing")
const SetMap = Symbol.for("SetMap")

export default {
  name: "Map2DShared",
  mixins: [ProcessingsTilesMixin, PostProcessingsTilesMixin],
  inject: { _Processing, SetMap },
  data: () => ({
    score: "",
    comment: "",
  }),
  methods: {
    onMounted() {
      const options = {
        drawControl: false,
        zoomControl: false,
        scrollWheelZoom: true,
        editable: true,
        editOptions: {
          polygonEditorClass: HorusPolygonEditor,
          polylineEditorClass: HorusPolylineEditor,
          vertexMarkerClass: HorusVertexMarker,
        },
      }
      this.Map = window.L.HorusLeaflet.map(this.Processing["id_processing"], options)
      this.setupBaseMap()
      this.Map.fitBounds(this.getProcessingBounds(this.Processing))
      this.Map.removeControl(this.Map.attributionControl)
      this.setZoomControls()
      this.setupMapEvents()
      this.loadFeatures()
      this.setShapeMessages()
      this.$nextTick(() => {
        MapViewEventBus.$emit("setup-complete")
      })
    },

    setZoomControls() {
      window.L.control.zoom({
        position: 'bottomcenter',
        zoomOutText: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_74_1647)"><path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.25 7.5H9.75" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.75 15.75L11.25 11.25" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_74_1647"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>',
        zoomInText: '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_74_1646)"><path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.25 7.5H9.75" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 5.25V9.75" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.75 15.75L11.25 11.25" stroke="#212222" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_74_1646"><rect width="18" height="18" fill="white"/></clipPath></defs></svg>'
      }).addTo(this.Map)
    },

    setupBaseMap() {
      window.L.tileLayer("https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}", {
        attribution: "Map data: &copy; Google Maps",
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        maxZoom: BASE_MAX_ZOOM,
        minZoom: BASE_MIN_ZOOM,
        tms: false,
        label: "Google Maps Hybrid",
      })
        .addTo(this.Map.featureGroups[FEATURE_GROUPS.BASE_MAP])
    },
    setupMapEvents() {
      this.Map.on(window.L.Draw.Event.CREATED, this.onDrawCreated)
    },

    onDrawCreated(event) {
      window.L.DomEvent.stopPropagation(event)
      const layer = event.layer,
        layerType = event.layerType
      switch (layerType) {
        case window.L.Draw.Polygon.TYPE:
          this.onFieldDrawCreated(layer)
          break
        case window.L.Draw.Polyline.TYPE:
          this.onPolylineDrawCreated(layer)
          break
        case window.L.Draw.Marker.TYPE:
          this.onMarkerDrawCreated(layer)
          break
        default:
          this.$notify(new NotificationOptions({
            message: "Tipo de geometria não suportada",
            type: NOTIFICATION_TYPES.ERROR,
          }))
          break
      }
    },
    onFieldDrawCreated(layer) {
      const wkt = new Wkt.Wkt()
      const geojsonObject = layer.toGeoJSON()
      const geoField = wkt.fromObject(geojsonObject.geometry)

      const fieldData = {
        cd_processing: this.Processing["id_processing"],
        geo_field: geoField.write(),
      }
      createField(fieldData)
        .then(res => {
          const field = res.data.data
          window.L.HorusLeaflet.field(field, {}, this.Map, true)
            .addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
        })
    },
    onPolylineDrawCreated(layer) {
      const wkt = new Wkt.Wkt()
      const geojsonObject = layer.toGeoJSON()
      const flDistance = getPolylineDistance(layer)
      const geoFeature = wkt.fromObject(geojsonObject.geometry)

      const featureData = {
        cd_processing: this.Processing["id_processing"],
        json_extra: {
          fl_distance: flDistance,
        },
        geo_feature: geoFeature.write(),
      }
      createProcessingGeometries(featureData)
        .then(res => {
          const feature = res.data.data
          window.L.HorusLeaflet.polyline(feature, {}, this.Map, true)
            .addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
        })
    },
    onMarkerDrawCreated(layer) {
      const wkt = new Wkt.Wkt()
      const geojsonObject = layer.toGeoJSON()
      const geoFeature = wkt.fromObject(geojsonObject.geometry)

      const featureData = {
        cd_processing: this.Processing["id_processing"],
        geo_feature: geoFeature.write(),
      }
      createProcessingGeometries(featureData)
        .then(res => {
          const feature = res.data.data
          window.L.HorusLeaflet.marker(feature, {}, this.Map, true)
            .addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
        })
    },

    loadFeatures() {
      const wkt = new Wkt.Wkt()
      const authToken = ''

      FloatingCardsEventBus.$emit("requestProcessing", authToken, this.Processing["id_processing"])

      listFieldsByProcessingShared(this.Processing["id_processing"])
        .then(res => {
          const fields = res.data.data
          forEach(fields, field => {
            window.L.HorusLeaflet.field(field, {}, this.Map).addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
          })
        })

      listProcessingGeometriesByProcessingShared(this.Processing["id_processing"])
        .then(res => {
          const features = res.data.data
          forEach(features, feature => {
            const geoJSON = wkt.read(feature["geo_feature"]).toJson()
            switch (geoJSON["type"]) {
              case GEOMETRY_TYPES.LINE_STRING:
                window.L.HorusLeaflet.polyline(feature, {}, this.Map).addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
                break
              case GEOMETRY_TYPES.POINT:
                window.L.HorusLeaflet.marker(feature, {}, this.Map).addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
                break
              case GEOMETRY_TYPES.POLYGON:
                window.L.HorusLeaflet.geoJSON(feature, {}, this.Map).addTo(this.Map.featureGroups[FEATURE_GROUPS.FEATURES])
                break
              default:
                break
            }
          })
        })
    },

    setShapeMessages() {
      //Override das mensagens dos shapes
      window.L.drawLocal = {
        draw: {
          toolbar: {
            // #TODO: this should be reorganized where actions are nested in actions
            // ex: actions.undo  or actions.cancel
            actions: {
              title: "Cancel drawing",
              text: "Cancel",
            },
            finish: {
              title: "Finish drawing",
              text: "Finish",
            },
            undo: {
              title: "Delete last point drawn",
              text: "Delete last point",
            },
            buttons: {
              polyline: "Draw a polyline",
              polygon: "Draw a polygon",
              rectangle: "Draw a rectangle",
              circle: "Draw a circle",
              marker: "Draw a marker",
              circlemarker: "Draw a circlemarker",
            },
          },
          handlers: {
            circle: {
              tooltip: {
                start: "Click and drag to draw circle.",
              },
              radius: "Radius",
            },
            circlemarker: {
              tooltip: {
                start: "Click map to place circle marker.",
              },
            },
            marker: {
              tooltip: {
                start: "Click map to place marker.",
              },
            },
            polygon: {
              tooltip: {
                start: "Click to start drawing.",
                cont: "Click to continue the area.",
                end: "Click on the first point to finish the area.",
              },
            },
            polyline: {
              error: "<strong>Error:</strong> there can be no intersection in the area!",
              tooltip: {
                start: "Click to start drawing shape.",
                cont: "Click to continue drawing line.",
                end: "Click last point to finish line.",
              },
            },
            rectangle: {
              tooltip: {
                start: "Click and drag to draw rectangle.",
              },
            },
            simpleshape: {
              tooltip: {
                end: "Release mouse to finish drawing.",
              },
            },
          },
        },
      }
    },

    getProcessingBounds(processing) {
      const processingBounds = [
        processing["json_processing_extents"]["coord_0"]["longitude"],
        processing["json_processing_extents"]["coord_0"]["latitude"],
        processing["json_processing_extents"]["coord_2"]["longitude"],
        processing["json_processing_extents"]["coord_2"]["latitude"],
      ]
      const firstCorner = window.L.latLng(
        processingBounds.slice(0, 2).reverse()[0].toString(),
        processingBounds.slice(0, 2).reverse()[1].toString(),
      )
      const lastCorner = window.L.latLng(
        processingBounds.slice(2, 4).reverse()[0].toString(),
        processingBounds.slice(2, 4).reverse()[1].toString(),
      )
      return window.L.latLngBounds(firstCorner, lastCorner)
    },
  },
  computed: {
    Map: {
      get() {
        return this._Map()
      },
      set(value) {
        this.SetMap(value)
      },
    },
    Processing() {
      return this._Processing()
    },
  },
  mounted() {
    this.onMounted()
  },
}
</script>

<style scoped lang="scss">
.map {
  width: 100vw;
}
</style>
